<template>

  <div class="content_journal" v-if="proofLoginStatus">

  	<h1 class="entry-title ueberschrift">Empfangsjournal</h1>

  	<div class="woocommerce-error" role="alert" v-if="summaryerror">Fehler. {{ summaryerrordescription }}</div>

  	<button @click="toggleFilterBlock()" class="closeButtonAndBack smaller" :class="{ active: openFilter }" style="display:block;width:auto;margin-left:0px;padding-left:20px;padding-right:20px;float:none;"><i class="fa-solid fa-filter" style="padding-right:4px;"></i> {{filterButtonLabel}}</button>
  	<div v-if="openFilter" class="filterBlock" tabindex="0" v-on:keyup.enter="listDocuments('*',true,getMaxRowsPerPageCommit,false,true)" style="outline:none;">
  		<div class="cols">
	  		<div class="col1">
	  			<div class="inputsection">
				  	<label>Dokumententyp</label><br/>
				  	<!-- <multiselect v-model="dokumententyp" :options="dokumententyp_options" :multiple="true" placeholder="Bitte auswählen" label="name" track-by="name" deselectLabel="Entfernen" selectLabel="Auswählen" selectedLabel="Ausgewählt" tabindex="1"></multiselect> -->
				  	<input type="text" v-model="dokumententyp" tabindex="1">
			  	</div>
			  	<div class="inputsection">
			  		<label>Dateiname</label><br/>
				    <input type="text" v-model="dateiname" tabindex="2">
				</div>
	  		</div>
	  		<div class="col2">
	  			<div class="inputsection">
		  			<label>Rechnungssteller</label><br/>
				  	<input type="text" v-model="rechnungssteller" tabindex="3">
			  	</div>
			  	<div class="inputsection">
				  	<label>Eingangsdatum</label><br/>
				  	<date-picker v-model="eingangsdatum" range format="DD.MM.YYYY" range-separator=" - " tabindex="4"></date-picker>
				 </div>
	  		</div>
	  		<div class="col3">
	  			<div class="inputsection">
	  				<label>Belegnummer</label><br/>
			  		<input type="text" v-model="belegnummer" tabindex="5">
			  	</div>
			  	<div class="inputsection">
			  	<label>Validierungsstatus</label><br/>
				  	<!-- <select v-model="validierungsstatus">
				  		<option value=""></option>
				        <option value="Rechnung_no-e-invoice_true">{{$status['Rechnung_no-e-invoice_true']}}</option>
				        <option value="Rechnung_validation-failed_true">{{$status['Rechnung_validation-failed_true']}}</option>
				        <option value="Rechnung_valid-e-invoice_true">{{$status['Rechnung_valid-e-invoice_true']}}</option>
				        <option value="Rechnung_invalid-e-invoice_true">{{$status['Rechnung_invalid-e-invoice_true']}}</option>
				    </select> -->
				    <multiselect v-model="validierungsstatus" :options="validierungsstatus_options" :multiple="true" placeholder="Bitte auswählen" label="name" track-by="name" deselectLabel="Entfernen" selectLabel="Auswählen" selectedLabel="Ausgewählt" tabindex="6"></multiselect>
				</div>
	  		</div>
  		</div>
	    <div class="buttonsBlock">
		  	<button class="closeButtonAndBack smaller black" style="width:auto;margin-left:0px;padding-left:20px;padding-right:20px;float:left;" @click="listDocuments('*',true,getMaxRowsPerPageCommit,false,true)">Filtern</button>
		  	<button class="closeButtonAndBack smaller white"style="width:auto;padding-left:20px;padding-right:20px;float:left;margin-left:5px;" @click="listDocuments('*',true,getMaxRowsPerPageCommit,false,false,true)">Abbrechen</button>
	  	</div>
  	</div>

  	<table v-if="documents.length > 0" class="documentslist" style="border-bottom:0px;">
		<tr class="head">
			<th @click="sortBuilder('statuslist','asc')" style="cursor:pointer;max-width: 100px;">
				Status
				<i v-if="getSortSetting.sort == 'statuslist'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
				<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
			</th>
			<th style="cursor:pointer;max-width: 160px;">
				Dokumententyp
				<i v-if="getSortSetting.sort == 'dokumententyp'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
				<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
			</th>
			<th style="word-wrap: break-word;max-width: 290px;cursor:pointer;" @click="sortBuilder('kreditorname','asc')">
				Rechnungssteller
				<i v-if="getSortSetting.sort == 'kreditorname'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
				<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
			</th>
			<th @click="sortBuilder('belegnummer','asc')" style="cursor:pointer;max-width: 150px;">
				Belegnummer
				<i v-if="getSortSetting.sort == 'belegnummer'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
				<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
			</th>
			<th style="text-align:right;cursor:pointer;max-width:135px;" @click="sortBuilder('belegdatum','asc')">
				Belegdatum
				<i v-if="getSortSetting.sort == 'belegdatum'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
				<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
			</th>
			<th style="text-align:right;word-wrap: break-word;max-width: 170px;cursor:pointer;" @click="sortBuilder('stored_date','asc')">
				Eingangsdatum
				<i v-if="getSortSetting.sort == 'stored_date' || getSortSetting.sort == null" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
				<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
			</th>
			<th style="text-align:right;word-wrap: break-word;max-width: 200px;cursor:pointer;" @click="sortBuilder('filename','asc')">
				Dateiname
				<i v-if="getSortSetting.sort == 'filename'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
				<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
			</th>
			<th style="text-align:right;cursor:pointer;max-width:110px;" @click="sortBuilder('content-type','asc')">
				Dateityp
				<i v-if="getSortSetting.sort == 'content-type'" class="fa-solid fa-sort" style="font-size:11px;color:#fff;"></i>
				<i v-else class="fa-solid fa-sort" style="font-size:11px;color:#8c8889;"></i>
			</th>
		</tr>
  		<tr v-for="(item, $index) of documents" @click="showDocument(item.id)">
  			<td style="max-width: 100px;">
  				<span v-if="item['statuslist']">
  					<span v-if="item['statuslist'][0] == 'Rechnung_valid-e-invoice_true'" style="color:#7cb430;font-weight:bold;">
  						<i class="fa-solid fa-circle-check" style="font-size:20px;"></i><br/>valid
  					</span>
  					<span v-else-if="item['statuslist'][0] == 'Rechnung_validation-failed_true'" style="color:#0a0a0a;font-weight:bold;">
  						<i class="fa-solid fa-solid fa-circle-info" style="font-size:20px;"></i><br/>fehlgeschlagen
  					</span>
  					<span v-else-if="item['statuslist'][0] == 'Rechnung_invalid-e-invoice_true'" style="color:#af301c;font-weight:bold;">
  						<i class="fa-solid fa-circle-xmark" style="font-size:20px;"></i><br/>invalid
  					</span>
  					<span v-else-if="item['statuslist'][0] == 'Rechnung_no-e-invoice_true'" style="color:#0a0a0a;font-weight:bold;">
  						<i class="fa-solid fa-circle-exclamation" style="font-size:20px;"></i><br/>keine<br/>E-Rechnung
  					</span>
  					<span v-else style="color:#0a0a0a;">
  						<!-- <i class="fa-solid fa-file-invoice" style="font-size:20px;"></i> -->
  					</span>
  				</span>
  			</td>
  			<td style="max-width: 160px;">{{item['belegtyp']}}</td>
  			<td style="max-width: 290px;">{{item['kreditorname']}}</td>
  			<td style="max-width: 150px;">{{item['belegnummer']}}</td>
  			<td style="text-align:right;max-width:135px;">{{item['belegdatum'] | formatDate}}</td>
  			<td style="text-align:right;word-wrap: break-word;max-width: 170px;">{{item['filedate'] | formatDateTime}}</td>
  			<td style="text-align:right;word-wrap: break-word;max-width: 200px;">{{item['filename']}}</td>
  			<td style="text-align:right;max-width:110px;">
  				<span v-if="item['statuslist']">
	  				<span v-if="item['statuslist'][0] == 'Rechnung_no-e-invoice_true'">
	  					<i v-if="item['cm:mimetype'] == 'application/pdf'" class="fa-solid fa-file-pdf" style="font-size:20px;"></i>
	  				</span>
	  				<span v-else>
	  					<i v-if="item['cm:mimetype'] == 'application/pdf'" class="fa-solid fa-file-code" style="font-size:20px;"></i>
	  					<i v-else class="fa-solid fa-code" style="font-size:16px;"></i>
	  				</span>
  				</span>
  			</td>
  		</tr>
  		<tr class="footer" style="background-color:#5f5e5e;">
  			<td colspan="8" style="color:#fff;text-align:right;padding: 15px 20px;font-weight:700;">insgesamt {{treffer}} Einträge</td>
  		</tr>
  	</table>
  	<table v-else class="documentslist">
  		<tr class="head">
			<th>Status</th>
			<th>Dokumententyp</th>
			<th>Rechnungssteller</th>
			<th>Belegnummer</th>
			<th style="text-align:right;">Belegdatum</th>
			<th style="text-align:right;">Eingangsdatum</th>
			<th style="text-align:right;">Dateiname</th>
			<th style="text-align:right;">Dateityp</th>
		</tr>
		<tr>
			<td colspan="8" style="font-weight:bold;text-align:center;">Keine Dokumente vorhanden.</td>
		</tr>
  	</table>
  	
  	<div style="overflow:hidden;">
	  	<div style="float:left;">
			<div v-if="getMaxRowsPerPageCommit == 25" class="closeButtonAndBack floatleft smaller active fixlineheight" @click="listDocuments('*',true,25,true)" style="margin-left:0px;">25</div>
			<div v-else class="closeButtonAndBack floatleft smaller fixlineheight" @click="listDocuments('*',true,25,true)" style="margin-left:0px;">25</div>
	  		<div v-if="getMaxRowsPerPageCommit == 50" class="closeButtonAndBack floatleft smaller active fixlineheight" @click="listDocuments('*',true,50,true)">50</div>
	  		<div v-else class="closeButtonAndBack floatleft smaller fixlineheight" @click="listDocuments('*',true,50,true)">50</div>
	  		<div v-if="getMaxRowsPerPageCommit == 100" class="closeButtonAndBack floatleft smaller active fixlineheight" @click="listDocuments('*',true,100,true)">100</div>
	  		<div v-else class="closeButtonAndBack floatleft smaller fixlineheight" @click="listDocuments('*',true,100,true)">100</div>
	  		<div v-if="getMaxRowsPerPageCommit == 200" class="closeButtonAndBack floatleft smaller active fixlineheight" @click="listDocuments('*',true,200,true)">200</div>
	  		<div v-else class="closeButtonAndBack floatleft smaller fixlineheight" @click="listDocuments('*',true,200,true)">200</div>
	  	</div>

	  	<div style="float:right">
	  		<div v-if="getPage != 0" class="closeButtonAndBack floatleft fixlineheight" @click="listDocuments(getAllMarkers[getPage - 1], false, getMaxRowsPerPageCommit)"><i class="fa-solid fa-angle-left"></i></div>
	  		<div v-else class="closeButtonAndBack floatleft disable fixlineheight"><i class="fa-solid fa-angle-left"></i></div>
	  		<div v-if="forwardTest" class="closeButtonAndBack floatleft fixlineheight" @click="listDocuments(markerForward, true, getMaxRowsPerPageCommit)"><i class="fa-solid fa-angle-right"></i></div>
	  		<div v-else class="closeButtonAndBack floatleft disable fixlineheight"><i class="fa-solid fa-angle-right"></i></div>
	  	</div>
  	</div>
 
  </div>

</template>

<script>

//import axios from 'axios';
import DocumentSingleView from './DocumentSingleView'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import datatypes from '../public/qualified_datatypes.json'

export default {
	components: { Multiselect, DatePicker },
	data() {
		return {
			apiResponse: '', // initial loading or error messages.
			wpPosts: [], // REST API response data goes here.
			wpData, // global data made available via wp_localize_script.
			user: {
				username: '',
				password: ''
			},
			summaryerror: false,
			summaryerrordescription: '',
			forwardTest: true,
			openFilter: false,
			filterButtonLabel: "Filter öffnen",
			belegnummer: '',
			validierungsstatus: '',
			datenherkunft: '',
			eingangsdatum: '',
			rechnungssteller: '',
			dokumententyp: '',
			// validierungsstatus_options: [
			// 	'Rechnung_no-e-invoice_true': 'keine E-Rechnung',
			// 	'Rechnung_validation-failed_true' : 'E-Rechnung'
			// ]
			dokumententyp_options: [
		        {name: 'Rechnung', value: 'Rechnung'}
		    ],
			validierungsstatus_options: [
		        {name: 'keine E-Rechnung', value: 'Rechnung_no-e-invoice_true'},
		        {name: 'valid', value: 'Rechnung_valid-e-invoice_true'},
		        {name: 'fehlgeschlagen', value: 'Rechnung_validation-failed_true'},
		        {name: 'invalid', value: 'Rechnung_invalid-e-invoice_true'}
		    ],
		    treffer: 0,
		    datatypes: datatypes
		};
	},

	beforeMount() {
		this.$store.commit('setMaxRowsPerPage', localStorage.getItem('maxRowsPerPage'))
		if (this.getAllMarkers) {
			this.listDocuments(this.getAllMarkers[this.getPage], null, this.getMaxRowsPerPageCommit, false);
		} else {
			this.listDocuments("*", null, this.getMaxRowsPerPageCommit, false)
		}
	},

	computed: {
      	proofLoginStatus() {
      		if (this.$store.getters.isPortinvoiceLoggedIn != "") {
      			return true
      		} else {
      			this.$router.push('/noAccess');
      		}
      	},
		documents() {
			var documents = this.$store.getters.getDocuments
			console.log(documents)
			return documents
		},
		markerForward() {
			var marker = this.$store.getters.getPageMarkerForward
			return marker
		},
		markerBackward() {
			var marker = this.$store.getters.getPageMarkerBackward
			return marker
		},
		getAllMarkers() {
			var markers = this.$store.getters.getAllMarkers
			return markers			
		},
		getPage() {
			var page = this.$store.getters.getPage
			return page	
		},
		getMaxRowsPerPage() {
			return localStorage.getItem('maxRowsPerPage')
		},
		getMaxRowsPerPageCommit() {
			return this.$store.getters.getMaxRowsPerPageCommit
		},
		getSortSetting() {
			return this.$store.getters.getSortSetting
		}
	},

	mounted() {

	},

	methods: {

		getCounter(ticket) {
			var data = {
				'nonce': this.wpData.nonce,
				'restURL': this.wpData.rest_url,
				'ticket': ticket
			}
			this.$store.dispatch('getCounter', data)
				.then(resp => {
					console.log(resp.data)
				})
				.catch(err => {
					console.log("getCounter kann nicht angezeigt werden")
				})
		},

		showDocument(noderef) {
			//console.log(noderef)
			this.$store.commit('setLoadingWorkingScreen')
			var ticket = this.$store.getters.getAccessTicket
			this.$router.push({
				name: 'DocumentSingleView',
				params: {
					noderef: noderef,
					ticket: ticket,
					referer: 'journal'
				}
			})
		},

		searchInDatatypes(searchString) {
			var source = this.datatypes['urn:xoev-de:kosit:codeliste:untdid.1001_4'].data_types
		    var results = []
		    searchString = searchString.toUpperCase()
			for (let key in source) {
				var germanText = source[key].localization.de
				var englishText = source[key].localization.en
				if (germanText.name.toUpperCase().indexOf(searchString) !== -1 ||
					englishText.name.toUpperCase().indexOf(searchString) !== -1 ||
					searchString == key) {
						results.push(key)
				}
			}
		    return results
		},

		queryBuilder(query) {
			if (this.dokumententyp != "") {
				var filterDataTypes = this.searchInDatatypes(this.dokumententyp)
				if (filterDataTypes.length > 0) {
					var datentypen_query = ""
					for (var i = 0; i < filterDataTypes.length; i ++) {
						if (i !== filterDataTypes.length - 1) {
							datentypen_query = datentypen_query + "qualifizierter_datentyp:" + filterDataTypes[i] + " OR "
						} else {
							datentypen_query = datentypen_query + "qualifizierter_datentyp:" + filterDataTypes[i]
						}
					}
					//console.log(datentypen_query)
					query = query + " AND (" + datentypen_query + ")"
				} else {
					query = query + " AND qualifizierter_datentyp:" + this.dokumententyp
				}
			}
			if (this.belegnummer != "") {
				query = query + " AND belegnummer:" + this.belegnummer
			}
			if (this.datenherkunft != "") {
				query = query + " AND datenherkunft:" + this.datenherkunft
			}
			if (this.eingangsdatum != "" && this.eingangsdatum[0] != null && this.eingangsdatum[1] != null) {
				var startdate = moment(this.eingangsdatum[0]).subtract(2, 'hours').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
				var enddate = moment(this.eingangsdatum[1]).add(24, 'hours').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
				query = query + " AND stored_date:" + '["' + startdate + '" TO "' + enddate + '"]'
			}
			if (this.rechnungssteller != "") {
				query = query + " AND kreditorname:" + this.rechnungssteller
			}
			if (this.validierungsstatus != "") {
				var typen = ""
				this.validierungsstatus.forEach((element, idx, array) => {
					if (idx === array.length - 1){ 
						typen = typen + element['value']
					} else {
						typen = typen + element['value'] + ","
					}
				})
				var result = typen.replace(/,/g, " OR statuslist:")
				query = query + " AND (statuslist:" + result + ")"
			}
			return query
		},

		sortBuilder(sort, sortDirection) {
			this.$store.commit('setPageToZero')
			this.$store.commit('emptyAllMarkers')

			console.log("BEGIN SORTSETTING")
			console.log(this.$store.getters.getSortSetting)
			
			var currentSortSettings = this.$store.getters.getSortSetting
			if (Object.keys(currentSortSettings).length !== 0) {
				console.log("nicht leer")
				if (currentSortSettings.sort != sort) {
					this.listDocuments("*", null, this.getMaxRowsPerPageCommit, false, false, false, sort, sortDirection)
				} else {
					if (currentSortSettings.sortDirection == "desc") {
						sortDirection = "asc"
					} else {
						sortDirection = "desc"
					}
					this.listDocuments("*", null, this.getMaxRowsPerPageCommit, false, false, false, sort, sortDirection)
				}
			} else {
				// if (sort == "stored_date" && sortDirection == "desc") {
				// 	sortDirection = "asc"
				// }
				this.listDocuments("*", null, this.getMaxRowsPerPageCommit, false, false, false, sort, sortDirection)
			}

			var sortSetting = {
				'sort': sort,
				'sortDirection': sortDirection
			}
			this.$store.commit('setSortSetting', sortSetting)

			console.log("END SORTSETTING")
			console.log(this.$store.getters.getSortSetting)
		},

		/*listDocuments(marker = "*", page = null, rows = 25, resetMarker = false, filter = false, resetFilter = false, sort = "stored_date", sortDirection = "desc") {
			
			if (page != null) {
	        	//sort und sortDirection aus Commit abfragen und berücksichtigen beim Blättern
		        var currentSortSettings = this.$store.getters.getSortSetting
				if (Object.keys(currentSortSettings).length !== 0) {
					sort = currentSortSettings.sort
					sortDirection = currentSortSettings.sortDirection
				}
				if (page) {
					this.$store.commit('addPage')
				} else {
					this.$store.commit('subtractPage')
				}
			}

			if (resetMarker) {
				this.$store.commit('setPageToZero')
				this.$store.commit('emptyAllMarkers')
				//this.$store.commit('emptySortOrder')
				this.$store.commit('setMaxRowsPerPage', rows)
				localStorage.setItem('maxRowsPerPage', rows)
				this.resetFilterValues()
			}
	        if (filter) {
	         	this.$store.commit('setPageToZero')
	         	this.$store.commit('emptyAllMarkers')
	        }
	        if (resetFilter) {
	         	this.$store.commit('setPageToZero')
	         	this.$store.commit('emptyAllMarkers')
	         	this.resetFilterValues()
	        }
			var query = "AND belegtyp:Rechnung"
			query = this.queryBuilder(query)
			
			var data = {
	            'nonce': this.wpData.nonce,
	            'restURL': this.wpData.rest_url
	        }
	        this.$store.commit('setLoadingWorkingScreen')
	        this.$store.commit('emptyDocuments')
			this.$store.dispatch('retrieveTicket', data)
		        .then(resp => {
		        	var ticket = resp.data.ticket
					var data = {
						'nonce': this.wpData.nonce,
						'restURL': this.wpData.rest_url,
						'ticket': ticket,
						'mark': marker,
						'mandant': this.$store.getters.getMandant,
						'query': query,
						'rows': rows,
						'sort': sort,
						'sortDirection': sortDirection
					}
				   	this.$store.dispatch('getDocumentsMarkedQuery', data)
					    .then(resp => {

					    	if (resp.data.description == "invalid ticket") {
					    		var data = {
						            'nonce': this.wpData.nonce,
						            'restURL': this.wpData.rest_url
						        }
								this.$store.dispatch('checkAndCreatePortinvoiceTicket', data)
									.then(resp => {
										console.log("neues Ticket erzeugt und in Datenbank gespeichert")
										if (resp.data.code == 200) {
								        	var ticket = resp.data.ticket
											var data = {
												'nonce': this.wpData.nonce,
												'restURL': this.wpData.rest_url,
												'ticket': ticket,
												'mark': marker,
												'mandant': this.$store.getters.getMandant,
												'query': query,
												'rows': rows,
												'sort': sort,
												'sortDirection': sortDirection
											}
										   	this.$store.dispatch('getDocumentsMarkedQuery', data)
											    .then(resp => {
										    		console.log("nachdem Ticket erzeugt -> nun Dokumente geladen")

										    		if (resp.data.data.mark != null) {
											    		var nextPageMarker = resp.data.data.mark
												        this.$store.commit('setDocuments', resp.data.data.docs)
												        this.$store.commit('addPageMarkerForward', nextPageMarker)
												        this.$store.commit('saveAllMarkers', marker)

												        var data = {
															'nonce': this.wpData.nonce,
															'restURL': this.wpData.rest_url,
															'ticket': ticket,
															'mark': nextPageMarker,
															'mandant': this.$store.getters.getMandant,
															'query': query,
															'rows': rows,
															'sort': sort,
															'sortDirection': sortDirection
														}
														this.$store.dispatch('getDocumentsMarkedQuery', data)
															.then(resp => {
																if (resp.data.data.mark == null) {
																	//Dokumente auf der Folgeseite gibt es nicht
																	this.forwardTest = false
																} else {
																	this.forwardTest = true
																}
																this.$store.commit('setStopLoadingWorkingScreen')
															})
															.catch(err => {
																this.forwardTest = false
																this.$store.commit('setStopLoadingWorkingScreen')
																console.log("Dokumente auf der Folgeseite konnten nicht geladen werden.")
															})
												    } else {
												    	this.forwardTest = false
												    	this.$store.commit('setStopLoadingWorkingScreen')
												    	console.log("Keine Dokumente vorhanden.")
												    }

											    })
											    .catch(err => {
											    	this.$store.commit('setStopLoadingWorkingScreen')
													console.log("Ticket immer noch fehlerhaft -> keine Dokumente geladen")
											    })
										} else {
											console.log("neues Ticket konnte nicht erzeugt werden #1")
											this.$store.commit('setStopLoadingWorkingScreen')											
										}

									})
									.catch(err => {
										console.log("neues Ticket konnte nicht erzeugt werden #2")
										this.$store.commit('setStopLoadingWorkingScreen')
									})


					    	} else {
					    		console.log("Ticket nicht neu erzeugt, aber Dokumente geladen")

					    		if (resp.data.data.mark != null) {

						    		var nextPageMarker = resp.data.data.mark
						    		this.treffer = resp.data.data.hits

						    		this.customizeBelegtypen(resp.data.data.docs)

							        this.$store.commit('setDocuments', resp.data.data.docs)
							        this.$store.commit('addPageMarkerForward', nextPageMarker)
							        this.$store.commit('saveAllMarkers', marker)

							        var data = {
										'nonce': this.wpData.nonce,
										'restURL': this.wpData.rest_url,
										'ticket': ticket,
										'mark': nextPageMarker,
										'mandant': this.$store.getters.getMandant,
										'query': query,
										'rows': rows,
										'sort': sort,
										'sortDirection': sortDirection
									}
									this.$store.dispatch('getDocumentsMarkedQuery', data)
										.then(resp => {
											if (resp.data.data.mark == null) {
												//Dokumente auf der Folgeseite gibt es nicht
												this.forwardTest = false
											} else {
												this.forwardTest = true
											}
											this.$store.commit('setStopLoadingWorkingScreen')
										})
										.catch(err => {
											this.forwardTest = false
											this.$store.commit('setStopLoadingWorkingScreen')
											console.log("Dokumente auf der Folgeseite konnten nicht geladen werden.")
										})
						    	} else {
						    		this.forwardTest = false
						    		this.$store.commit('setStopLoadingWorkingScreen')
						    		console.log("Keine Dokumente vorhanden.")
						    	}
					    	}

						})
						.catch(err => {
							console.log("Dokumente konnten nicht geladen werden.")
							this.$store.commit('setStopLoadingWorkingScreen')
						})
			    })
				.catch(err => {
				    this.$store.commit('setStopLoadingWorkingScreen')
				    console.log(err)
				})
		},*/

		listDocuments(marker = "*", page = null, rows = 25, resetMarker = false, filter = false, resetFilter = false, sort = "stored_date", sortDirection = "desc") {
			
			if (page != null) {
	        	//sort und sortDirection aus Commit abfragen und berücksichtigen beim Blättern
		        var currentSortSettings = this.$store.getters.getSortSetting
				if (Object.keys(currentSortSettings).length !== 0) {
					sort = currentSortSettings.sort
					sortDirection = currentSortSettings.sortDirection
				}
				if (page) {
					this.$store.commit('addPage')
				} else {
					this.$store.commit('subtractPage')
				}
			}

			if (resetMarker) {
				this.$store.commit('setPageToZero')
				this.$store.commit('emptyAllMarkers')
				//this.$store.commit('emptySortOrder')
				this.$store.commit('setMaxRowsPerPage', rows)
				localStorage.setItem('maxRowsPerPage', rows)
				this.resetFilterValues()
			}
	        if (filter) {
	         	this.$store.commit('setPageToZero')
	         	this.$store.commit('emptyAllMarkers')
	        }
	        if (resetFilter) {
	         	this.$store.commit('setPageToZero')
	         	this.$store.commit('emptyAllMarkers')
	         	this.resetFilterValues()
	        }
			var query = "AND belegtyp:Rechnung"
			query = this.queryBuilder(query)
			
			var data = {
	            'nonce': this.wpData.nonce,
	            'restURL': this.wpData.rest_url
	        }
	        this.$store.commit('setLoadingWorkingScreen')
	        this.$store.commit('emptyDocuments')

		    //var ticket = resp.data.ticket
			var data = {
				'nonce': this.wpData.nonce,
				'restURL': this.wpData.rest_url,
				//'ticket': ticket,
				'mark': marker,
				'mandant': this.$store.getters.getMandant,
				'query': query,
				'rows': rows,
				'sort': sort,
				'sortDirection': sortDirection
			}
			this.$store.dispatch('getDocumentsMarkedQuery', data)
				.then(resp => {
					if (resp.data.data.mark != null) {

						var nextPageMarker = resp.data.data.mark
						this.treffer = resp.data.data.hits

						this.customizeBelegtypen(resp.data.data.docs)

						this.$store.commit('setDocuments', resp.data.data.docs)
						this.$store.commit('addPageMarkerForward', nextPageMarker)
						this.$store.commit('saveAllMarkers', marker)

						var data = {
							'nonce': this.wpData.nonce,
							'restURL': this.wpData.rest_url,
							//'ticket': ticket,
							'mark': nextPageMarker,
							'mandant': this.$store.getters.getMandant,
							'query': query,
							'rows': rows,
							'sort': sort,
							'sortDirection': sortDirection
						}

						this.$store.dispatch('getDocumentsMarkedQuery', data)
							.then(resp => {
								if (resp.data.data.mark == null) {
									//Dokumente auf der Folgeseite gibt es nicht
									this.forwardTest = false
								} else {
									this.forwardTest = true
								}
								this.$store.commit('setStopLoadingWorkingScreen')
							})
							.catch(err => {
								this.forwardTest = false
								this.$store.commit('setStopLoadingWorkingScreen')
								console.log("Dokumente auf der Folgeseite konnten nicht geladen werden.")
							})

					} else {
						this.forwardTest = false
						this.$store.commit('setStopLoadingWorkingScreen')
						console.log("Keine Dokumente vorhanden.")
					}

				})
				.catch(err => {
					console.log("Dokumente konnten nicht geladen werden.")
					this.$store.commit('setStopLoadingWorkingScreen')
				})
	    },

		customizeBelegtypen(documents) {
			documents.forEach(x => {
				if (x.hasOwnProperty("datentyp_schema") && x.hasOwnProperty("qualifizierter_datentyp")) {
					var schema = x['datentyp_schema']
					var datentyp = x['qualifizierter_datentyp']
					if (this.datatypes[schema].data_types[datentyp].localization.de.name != "") {
						var customizeName = this.datatypes[schema].data_types[datentyp].localization.de.name
					} else {
						var customizeName = this.datatypes[schema].data_types[datentyp].localization.en.name
					}
					x['belegtyp'] = customizeName
				}
			});
		},

		resetFilterValues() {
			this.belegnummer = ""
	        this.validierungsstatus = ""
	        this.eingangsdatum = ""
	        this.rechnungssteller = ""
	        this.openFilter = false
			this.filterButtonLabel = "Filter öffnen"
		},

		toggleFilterBlock() {
			if (this.openFilter) {
				this.openFilter = false
				this.filterButtonLabel = "Filter öffnen"
			} else {
				this.openFilter = true
				this.filterButtonLabel = "Filter schließen"
			}
		}

	}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

.documentslist {
	width: 100%;
	margin-bottom: 30px;
	border-bottom: 15px solid #5f5e5e;
	margin-top: 30px;
}
.documentslist tr th, .documentslist tr td {
	text-align: left;
	font-size:15px;
}

table.documentslist tr.head {
	border-bottom: 1px solid #5f5e5e;
}

table.documentslist tr {
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    -ms-transition: all 0.2s;
    -o-transition: all 0.2s;
    transition: all 0.2s;
}

table.documentslist tr.head th {
	font-weight: bold;
	color: #fff;
padding: 15px 20px;
}

table.documentslist tr td {
padding: 20px;
}

table.documentslist tr:nth-child(even) {
	background-color: #f4f4f4;
}

table.documentslist tr:hover {
  background-color: #ccc;
  cursor: pointer;
}

table.documentslist tr:active {
	background-color: #a8332e;
	color: #fff;
}

table.documentslist tr.head, table.documentslist tr.head:hover {
  background-color: #5f5e5e;
  cursor: default;
}

ul.documentslist li {
   border-bottom:1px solid #ccc;
   padding-bottom:20px;
   padding-top:20px;
   padding-left: 20px;
	cursor:pointer;
}

ul.documentslist li:nth-child(1) {
	border-top:1px solid #ccc;
}

ul.documentslist li:nth-child(odd) {
   background-color: #f4f4f4;
}

</style>



// WEBPACK FOOTER //
// src/components/EmpfangsportalOverview.vue